/* soit_id of a row from the e-Invoice list API */
export const getRowId = (item) =>
  item?.sales_order?.soit_id ?? item?.soit_id ?? item?.irnDetails?.soit_id;

/* Rows of the e-Invoice list API response */
export const getEInvoiceList = (data) =>
  data?.data?.list ??
  data?.data?.orderList ??
  data?.data?.eInvoiceList ??
  (Array.isArray(data?.data) ? data.data : []);
